module.exports = __webpack_public_path__ + "img/Perttu001.2698b9f5.png";